import "./AuthenticationLayout.scss";
import { Outlet } from "react-router-dom";
import { LOGIN_LITERALS } from "../../constants/literals";
import BrandingImage from "../../components/shared/SVG/BrandingImage";

export default function AuthenticationLayout() {
  return (
    <div className="login-container d-flex h-100vh">
      <div className="left-container d-flex align-items-center justify-content-center p-2">
        <div>
          <BrandingImage color={"#ffffff"} className="branding-image" />
        </div>
      </div>
      <div className=" d-flex align-items-center flex-column justify-content-center authentication-right-container">
        <div className="d-flex align-items-center justify-content-center login-wrapper flex-column position-relative">
          <Outlet />
          <div className="support">
            <div className="copy-rights-wrapper d-flex justify-content-between">
              <div className="copy-rights-content">
                {LOGIN_LITERALS.copyRights}
              </div>
              <div className="d-flex gap-4 privacy-policy-wrapper">
                <span
                  className="link"
                  onClick={() => {
                    window.open(process.env.REACT_APP_TERMS_URL);
                  }}
                >
                  Terms of Use
                </span>
                <span
                  className="link"
                  onClick={() => {
                    window.open(process.env.REACT_APP_PRIVACY_URL);
                  }}
                >
                  Privacy Policy
                </span>
                <span
                  className="link"
                  onClick={() => {
                    window.open(process.env.REACT_APP_SUPPORT_LINK);
                  }}
                >
                  Support
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
